// extracted by mini-css-extract-plugin
export default {"list__container":"PeopleList_list__container__gkukN","list__item":"PeopleList_list__item__V-MiB","person__photo":"PeopleList_person__photo__jNdGP"};